import { StateGS } from "@ivanlog/gs";
import { App } from "../../App";
import { GUIControllerBase } from "../../controllers/GUIControllerBase";


export class StateApp extends StateGS {
    public static App: App;

    protected get app(): App { return StateApp.App; }
    protected get gui(): GUIControllerBase { return App.gui; }
    
    constructor(title: string, inHistory: boolean) {
        super(title, inHistory)        
    }

    public async lockguiAsync<T>(action: Promise<T>) { return App.gui.lockActionAsync<T>(action); }     
}
